export default "__VITE_ASSET__C_l2PRaZ__"